<template>
  <div> <!-- Element rădăcină -->
    <!--General Top Bar -->
    <!-- <general-top-bar :title="$t('pages.fidelities')"></general-top-bar> -->
      <div id="outer-container">
          <div ref="navButtons" class="card mar-bt-0 mar-to-10 max-z-index navButtons">
              <div class="card-content">
                  <div class="clearfix row pad-lf-10 pad-rg-10">
                      <a
                        class="btn btn-fill btn-primary"
                        :class="{ active: isLoyality }"
                        @click="openLoyality"
                      >{{$t('marketingFidelities.loyalityPoint')}}</a>
                      <a
                        class="btn btn-fill btn-primary"
                        :class="{ active: isUserLabeling }"
                        @click="openUserLabeling"
                      >{{$t('marketingFidelities.userLabeling')}}</a>
                  </div>
              </div>
          </div>
      </div>
      <div v-if="isLoyality">
        <Loyality />
      </div>
      <div v-if="isUserLabeling">
        <UserLabeling />
      </div>
  </div>
</template>

<script>
  // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
  import Loyality from './Loyality.vue'
  import UserLabeling from './UserLabel/UserLabeling.vue'

  export default {
    components: {
      // GeneralTopBar,
      Loyality,
      UserLabeling
    },
    data () {
      return {
        isLoyality: true,
        isUserLabeling: false
      }
    },
    methods: {
      openLoyality () {
        this.isLoyality = true
        this.isUserLabeling = false
      },
      openUserLabeling () {
        this.isLoyality = false
        this.isUserLabeling = true
      }
    }
  }
</script>

<style scoped>
.form-check {
display: flex;
gap: 10px;
align-items: flex-start;
}
.action-buttons {
display: flex;
justify-content: space-between;
align-items: center; /* Aliniază butoanele pe axa verticală */
margin-bottom: 15px;
}

.left-buttons {
display: flex;
}

.left-buttons el-button {
margin-right: 10px; /* Spațiere între butoane */
}

.right-button {
margin-left: auto; /* Asigură că butonul "Editare Multipla" se aliniază la dreapta */
}
.button-group {
display: flex; /* Folosește flexbox pentru alinierea orizontală */
justify-content: flex-end; /* Aliniază butoanele la dreapta */
}
.button-group .btn {
margin-right: 10px; /* Adaugă un spațiu între butoane */
}
.button-group .btn:last-child {
margin-right: 0; /* Elimină marginea dreaptă pentru ultimul buton */
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/Fidelities/Fidelities.vue